// =====================================================================
//  Helpers de libellés pour les enums OTP (listes déroulantes du BO).
//  Centralise la correspondance valeur <-> libellé affiché.
// =====================================================================

import {
    OtpAlphabet,
    OtpCase,
} from "../../Model/Otp/OtpStrategyModel.js";

interface IEnumItem<T> {
    value: T;
    text: string;
}

export class OtpEnumHelper {
    static readonly Alphabet: IEnumItem<OtpAlphabet>[] = [
        {value: OtpAlphabet.Numeric, text: "Numérique (0-9)"},
        {value: OtpAlphabet.Alphanumeric, text: "Alphanumérique (A-Z 0-9)"},
        {value: OtpAlphabet.AlphanumericNoAmbiguous, text: "Alphanumérique sans ambigus (O/0, I/1…)"},
    ];

    static readonly Case: IEnumItem<OtpCase>[] = [
        {value: OtpCase.Upper, text: "Majuscules"},
        {value: OtpCase.Lower, text: "Minuscules"},
        {value: OtpCase.Mixed, text: "Mixte"},
    ];

    static Text = <T>(list: IEnumItem<T>[], value: T | undefined): string => {
        const found = list.find((x) => x.value === value);
        return found ? found.text : "";
    };

    static Value = <T>(list: IEnumItem<T>[], text: string): T | undefined => {
        const found = list.find((x) => x.text === text);
        return found ? found.value : undefined;
    };

    static Texts = <T>(list: IEnumItem<T>[]): string[] => list.map((x) => x.text);
}
